import { motion } from 'framer-motion';
import React, { ReactNode } from 'react';

interface FoldAnimationProps {
  folded: boolean;
  children: ReactNode;
}

const FoldAnimation: React.FC<FoldAnimationProps> = ({ folded, children }) => {
  return (
    <motion.div
      initial={{
        originY: 0,
        height: 'auto',
        scaleY: 1,
      }}
      animate={{
        height: folded ? 0 : 'auto',
        scaleY: folded ? 0 : 1,
      }}
      transition={{
        type: 'spring',
        duration: 0.6,
        bounce: folded ? 0 : 0.2,
      }}
    >
      {children}
    </motion.div>
  );
};

export default FoldAnimation;
